<div class="container">
    <h1 class="page-title"><span class="icon"><i class="fas fa-pallet"></i></span>使用者資料預覽</h1>
    <p-card>
        <form>
            <div class="p-fluid formgrid grid" *ngIf="isShowUserProfile">
                <div class="field col-6">
                    <label class="title">Account</label>
                    <div>{{account}}</div>
                </div>
                <div class="field col-6">
                    <label class="title">UserType</label>
                    <div>{{userType}}</div>
                </div>
                <div class="field col-6">
                    <label class="title">Email</label>
                    <div>{{email}}</div>
                </div>
                <div class="field col-6">
                    <label class="title">UserName</label>
                    <div>{{userName}}</div>
                </div>
                <div class="field col-6">
                  <label class="title">Employee S/N</label>
                  <div>{{employCode}}</div>
              </div>
            </div>
            <div class="mt-2 mb-1 pt-3 top-solid">
              {{ 'UserScope.Header.DataPermission' | translate }}
            </div>
            <div class="pb-3 bottom-solid">
                <div *ngFor="let roleScope of roleScopes; let i = index" class="role-block">
                    <div class="p-fluid grid">
                        <div class="field col-6">
                            <div>{{roleScope.roleCode | optionsMapping:roleOptions}}</div>
                        </div>
                    </div>
                    <div *ngIf="hasRole('Tenant')" class="tenant-role p-fluid grid">
                        <div class="field col-12 pl-5">
                            <p-table [value]="roleScope.tenants" class="datatable" styleClass="p-datatable-gridlines">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Facility</th>
                                        <th>TenantCode</th>
                                        <th>OrgId</th>
                                        <th>Dept</th>
                                        <th>Brand</th>
                                        <th>Customer</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-tenant let-rowIndex="rowIndex">
                                    <tr>
                                        <td>
                                          <label>{{tenant.facility | optionsMapping:facilityOptions}}</label>
                                        </td>
                                        <td>
                                            <label>{{tenant.tenantCode | optionsMapping:tenantOptions}}</label>
                                        </td>
                                        <td>
                                            <label>{{tenant.orgId}}</label>
                                        </td>
                                        <td>
                                            <label>{{tenant.dept}}</label>
                                        </td>
                                        <td>
                                            <label>{{tenant.brand}}</label>
                                        </td>
                                        <td>
                                            <label>{{tenant.customer}}</label>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div *ngIf="hasRole('Shipping')" class="shipping-role p-fluid grid">
                        <div class="field col-12 pl-5">
                            <label>倉別</label>
                            <div>
                                <span class="tag" *ngFor="let shipping of roleScope.shippings">{{shipping | optionsMapping:facilityOptions}}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="hasRole('Forwarder')" class="forwarder-role p-fluid grid">
                        <div class="field col-12 pl-5">
                            <p-table [value]="roleScope.forwarders" class="datatable" styleClass="p-datatable-gridlines">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Forwarder</th>
                                        <th>Tenant</th>
                                        <th>Facility</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-forwarder let-rowIndex="rowIndex">
                                    <tr>
                                        <td>
                                            <label>{{forwarder.forwarderCode | optionsMapping:forwarderOptions}}</label>
                                        </td>
                                        <td>
                                            <label>{{forwarder.tenantCode | optionsMapping:tenantOptions}}</label>
                                        </td>

                                        <td>
                                            <label>{{forwarder.facility | optionsMapping:facilityOptions}}</label>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <!-- <div class="field col-12 pl-5">
                            <label>貨代</label>
                            <div>
                                <span class="tag" *ngFor="let forwarder of roleScope.forwarders">{{forwarder | optionsMapping:forwarderOptions}}</span>
                            </div>
                        </div> -->
                    </div>
                    <div *ngIf="hasRole('Customer')" class="cusotmer-role p-fluid grid">
                        <div class="field col-12 pl-5">
                            <label>客戶代碼</label>
                            <div>
                                <span class="tag" *ngFor="let customer of roleScope.customers">{{customer | optionsMapping:customerOptions}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </p-card>
</div>
